<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import Axios from 'axios'
import _ from 'lodash'
import WebCamera from '../../utility/web-camera'
import fullscreen from 'vue-fullscreen'
import Spinner from "vue-simple-spinner"
Vue.use(fullscreen)
import { isMobile } from '../../utility/deviceDetect/index'
import progressBar from '@/utility/progress-bar/progress-bar.vue'

export default {
  name: 'statewide-add-parts',
  props: {
    selectedMake: {
      type: String,
      default() { return '' }
    }
  },
  data() {
    return {
      isMobile,
      vehicleVinPhotos: [],
      partsPhotos: [],
      isDonutActive: false,
      isDonutActive2: false,
      capricornResult: false,
      description: '',
      parts: [],
      isCapricorNbrChecked: false,
      capricornNumber: '',
      make: this.selectedMake,
      partNumber: '',
      vinVehicle: '',
      isClickedSendForQuote: false,
      isClickedRegisterBtn: false,
      capricornEmail: '',
      isCapricornEmail: false,
      makes: [
        'Alfa Romeo', 'Audi', 'Bentley',
        'BMW', 'Cupra', 'Chrysler',
        'Fiat', 'Haval', 'Holden',
        'Isuzu', 'Jac', 'Jaguar',
        'Jeep', 'Kia', 'Land-Rover',
        'Lexus', 'Mazda', 'Mercedes-Benz',
        'Mini', 'Mitsubishi', 'MG',
        'Nissan', 'Polestar', 'Porsche',
        'RAM', 'Renault', 'SsangYong',
        'Suzuki', 'Toyota', 'Volkswagen',
        'Volvo', 'McLaren', 'Aston Martin',
        'Lamborghini', 'Lotus', 'Ferrari',
        'Abarth', 'Pagani', '3M',
        'Brabus', 'Ppg', 'Sikkens',
      ],
      isShowCameraAi: {
        vin: false,
        parts: false
      },
      isShowCameraPart: false,
      isShowBrowseAi: {
        vin: false,
        parts: false
      },
      isShowBrowsePart: false,
      isSentQuote: false,
      isFoundPrtNbrMatch: false,
      isAddAccount: false,
      isErrorFromSendQuote: false,
      isCheckEmail: true,
      isCheckEmail2: true,
      repairer: {
        name: '',
        postcode: '',
        state: '',
      },

      createAccountBusinessName: '',
      createAccountBusinessAddress: '',
      createAccountSuburb: '',
      createAccountState: '',
      createAccountPostcode: '',
      createAccountPhoneNumber: '',
      createAccountEmailAddress: '',
      createAccountSuccess: false,
      loadingAi: {
        vin: false,
        parts: false
      }
    }
  },
  components: {
    Multiselect,
    WebCamera,
    'vue-simple-spinner': Spinner,
    progressBar
  },
  computed: {
    isDisabledSendBtn() {
      return _.isEmpty(this.createAccountBusinessName) ||
        _.isEmpty(this.createAccountBusinessAddress) ||
        _.isEmpty(this.createAccountState) ||
        _.isEmpty(this.createAccountPostcode) ||
        _.isEmpty(this.createAccountPhoneNumber) ||
        _.isEmpty(this.createAccountEmailAddress) ||
        _.isEmpty(this.createAccountSuburb) ||
        this.isClickedRegisterBtn
    },
    isDisabledAddToQuoteBtn() {
      return !(!_.isEmpty(this.description) || !_.isEmpty(this.partNumber)) || _.isEmpty(this.make) || _.isEmpty(this.vinVehicle)
    },
    showWarningEmptyVinVehicle() {
      return ((!_.isEmpty(this.description) || !_.isEmpty(this.partNumber)) && _.isEmpty(this.vinVehicle))
    },
    isPartsHaveLoadingAi() {
      return _.some(this.parts, (item) => item.ai_load === true)
    }
  },
  created() {
    this.debouncedSearchPrtNbr = _.debounce(this.searchPrtNbr, 500)
    this.debounceCheckCapricornNbrFunction = _.debounce(this.checkCapricornNbrFunction, 500)
  },
  methods: {
    async onFileChange(event) {
      // Set loading state for the appropriate AI type
      if (this.isShowBrowseAi.vin) {
        this.loadingAi.vin = true
      }
      if (this.isShowBrowseAi.parts) {
        this.loadingAi.parts = true
      }

      const file = event.target.files[0];
      //console.log('file', file)

      if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            let base64 = e.target.result

            if (this.isShowBrowsePart) {
              this.partsPhotos.push(base64)
            }

            if (this.isShowBrowseAi.vin) {
              await this.analyzeVinPhoto([base64])
            }

            if (this.isShowBrowseAi.parts) {
              await this.analyzePartsPhoto([base64])
            }

          } catch (error) {
            console.error('Error processing file:', error)
          } finally {
            // Reset all flags and loading states
            this.isShowBrowsePart = false;
            this.isShowBrowseAi.vin = false;
            this.isShowBrowseAi.parts = false;
            this.loadingAi.vin = false;
            this.loadingAi.parts = false;

            // Clear the file input to allow selecting the same file again
            if (event.target) {
              event.target.value = '';
            }
          }
        };

        reader.onerror = (error) => {
          console.error('FileReader error:', error)
          // Reset loading states on error
          this.loadingAi.vin = false;
          this.loadingAi.parts = false;
          this.isShowBrowseAi.vin = false;
          this.isShowBrowseAi.parts = false;

          // Clear the file input
          if (event.target) {
            event.target.value = '';
          }
        };

        reader.readAsDataURL(file);
      } else {
        // No file selected, reset states
        this.loadingAi.vin = false;
        this.loadingAi.parts = false;
        this.isShowBrowseAi.vin = false;
        this.isShowBrowseAi.parts = false;
      }
    },
    openCameraAi(type) {
      if (type=='parts' && _.isEmpty(this.vinVehicle)){
        return
      }
      if (type=='parts'){
        this.isShowCameraPart=true
      }else{
        this.isShowCameraPart=false
      }
      if (this.isMobile) {
        this.isShowCameraAi[type] = true
      } else {
        this.isShowBrowseAi[type] = true
        this.$refs.fileInput.click()
      }
    },
    openCameraParts() {
      if (this.isMobile) {
        this.isShowCameraPart = true
      } else {
        this.isShowBrowsePart = true
        this.$refs.fileInput.click()
      }
    },
    async analyzeVinPhoto(images) {
      this.isShowBrowseAi.vin = false;
     await Axios.post('/stw/vin', { images: images })
        .then(resp => {
          if (resp.request.status == 200) {
            this.vinVehicle = resp.data.vin
          }
        })
        .catch(err => {
          console.log(err)
        }).finally(() => {
          this.loadingAi.vin = false
          this.vehicleVinPhotos = []


        })

    },
    async analyzePartsPhoto(photo) {
      let obj = {
        partDescription: '',
        partNumber: '',
        ai_load: true,
        completed: false
      }
      this.parts.push(obj)
      this.loadingAi.parts = false
      this.isShowCameraAi.parts = false
      this.isShowBrowseAi.parts = false;
      //mock
      // await new Promise((resolve) => {
      //   setTimeout(() => {
      //     resolve(
      //       obj.ai_load = false,
      //       obj.partDescription = 'TEST',
      //       obj.partNumber = 'TEST 555',
      //     )
      //   }, 8000)
      // })
      //Ready query. Need to uncomment and change if necessary assignment of partDescription and partNumber
      await Axios.post('/stw/part',{ images: photo } )
        .then(resp => {
          if (resp.request.status == 200) {
            console.log('part', resp.data.part)
            obj.partDescription = resp.data.part.part_name
            obj.partNumber = resp.data.part.part_number
            obj.completed = true

          }
        })
        .catch(err => {
          console.log(err)
        }).finally(() => {
          this.loadingAi.parts = false
          this.isShowBrowseAi.parts = false;
          setTimeout(() => {
            obj.ai_load = false
          }, 1000)
        })

      this.loadingAi.parts = false
      this.vehicleVinPhotos = []
      this.isShowBrowseAi.parts = false;
    },
    async onCloseCamera(photos) {
      this.vehicleVinPhotos = _.concat(this.vehicleVinPhotos, photos)
      if (this.isShowCameraAi.vin) {
        this.isShowCameraAi.vin = false
        this.loadingAi.vin = true
        await this.analyzeVinPhoto(this.vehicleVinPhotos)
        return
      }
      if (this.isShowCameraAi.parts) {
        this.isShowCameraAi.parts = false
        this.loadingAi.parts = true
        await this.analyzePartsPhoto(photos)
        return
      }
      this.partsPhotos = _.concat(this.partsPhotos, photos)
      this.isShowCameraPart = false
    },
    async onSendCamera(photos) {
        this.loadingAi.parts = true
        await this.analyzePartsPhoto(photos)
    },
    provideBusinessDetails() {
      this.isAddAccount = !this.isAddAccount
      setTimeout(() => {
        document.getElementById('btnCapicornAccount').scrollIntoView({ behavior: 'smooth' })
      }, 400)

    },
    checkEmail() {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.isCheckEmail2 = re.test(this.createAccountEmailAddress)
      if (!this.isCheckEmail2) {
        return
      }
      Axios({ url: '/stw/auth/check-email', data: { email: this.createAccountEmailAddress }, method: 'POST' })
        .then(resp => {
          this.isCheckEmail = !(resp && resp.data && resp.data.status === false)
        })
        .catch(err => {
          console.log(err)
        })
    },
    createAccountBtnSend() {
      if (!this.isCheckEmail || !this.isCheckEmail2) {
        return
      }
      this.isClickedRegisterBtn = true
      let data = {
        business: {
          name: this.createAccountBusinessName,
          address: this.createAccountBusinessAddress,
          suburb: this.createAccountSuburb,
          state: this.createAccountState,
          postcode: this.createAccountPostcode,
          phone: this.createAccountPhoneNumber,
          email: this.createAccountEmailAddress,
        },
        parts: this.parts,
        vin: this.vinVehicle,
        make: this.make,
      }
      Axios.post('/stw/register', data).then((response) => {
        if (response.data._status) {
          this.createAccountSuccess = true
          this.isClickedRegisterBtn = false
        }
      })
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    getRefElement(refName) {
      let ref = this.$refs[refName]

      if (Array.isArray(ref)) {
        ref = ref[0]
      }

      if (!ref) {
        return null
      }

      if (ref.$el) {
        return ref.$el.querySelector('input') || ref.$el
      }

      return ref
    },
    focusByRef(refName) {
      const el = this.getRefElement(refName)
      if (el && el.focus) {
        el.focus()
        return true
      }
      return false
    },
    changePositionByArrowKey(refName) {
      this.focusByRef(refName)
    },
    findPartRefByDirection(index, step, field, includeStart = false) {
      const partsCount = _.get(this, 'parts.length', 0)
      if (!partsCount) {
        return null
      }

      let currentIndex = includeStart ? index : index + step
      while (currentIndex >= 0 && currentIndex < partsCount) {
        const refName = field == 'qty'
          ? 'statewidePartQty' + currentIndex
          : 'statewidePartDescription' + currentIndex

        if (this.getRefElement(refName)) {
          return refName
        }
        currentIndex += step
      }

      return null
    },
    focusFirstPartQty() {
      const refName = this.findPartRefByDirection(0, 1, 'qty', true)
      if (refName) {
        this.focusByRef(refName)
      }
    },
    onPressPartArrowKey(index, event) {
      if (!event || !event.code) {
        return
      }

      let refName = null

      if (event.code == 'ArrowDown') {
        refName = this.findPartRefByDirection(index, 1, 'qty')
        if (!refName) {
          refName = this.findPartRefByDirection(0, 1, 'qty', true)
        }
      } else if (event.code == 'ArrowUp') {
        refName = this.findPartRefByDirection(index, -1, 'qty')
        if (!refName) {
          this.focusByRef('partNumber')
          event.preventDefault()
          return
        }
      } else {
        return
      }

      if (refName && this.focusByRef(refName)) {
        event.preventDefault()
      }
    },
    upperCase(field) {
      this[field] = _.toUpper(this[field])
    },
    async searchPrtNbr() {
      this.isDonutActive = true
      await this.sleep(1000)
      if (this.partNumber == '6n971627a') {
        this.isFoundPrtNbrMatch = true
      } else {
        this.isFoundPrtNbrMatch = false
      }
      this.isDonutActive = false
      return true
      // Axios.post('/fe/statewide/check-part-number', {
      //   number: this.partNumber
      // }).then((r) => {
      //   if (r.data._status) {
      //     this.isFoundPrtNbrMatch = true
      //   } else {
      //     this.isFoundPrtNbrMatch = false
      //   }
      // }).catch((e) => {
      //   this.isFoundPrtNbrMatch = false
      // })
    },
    addToQuoteList() {
      if ((!_.isEmpty(this.description) || !_.isEmpty(this.partNumber)) && !_.isEmpty(this.make) && !_.isEmpty(this.vinVehicle) || aiAdd) {
        let obj = {
          partDescription: _.cloneDeep(this.description),
          partNumber: _.cloneDeep(this.partNumber),
        }
        // let obj = { partDescription: _.cloneDeep(this.description) }
        // if( this.description.length == 0){
        //   obj = { partNumber: _.cloneDeep(this.partNumber) }
        // }
        if (this.partNumber == '6n971627a') {
          obj = { partDescription: 'Fuel Injector Connector', partNumber: _.cloneDeep(this.partNumber), isStock: true, }
        }
        this.parts.push(obj)
        this.description = ''
        this.partNumber = ''
        this.isFoundPrtNbrMatch = false
        this.isDonutActive = false
        this.$nextTick(() => {
          this.focusByRef('statewideAddDescription')
        })
        return true
      }
    },
    checkCapricornNbrFunction() {
      Axios.post('stw/check-capricorn', {
        number: this.capricornNumber
      }).then((r) => {
        if (r.data._status) {
          if (r.data.repairer) {
            this.repairer = r.data.repairer
          }
          this.isCapricorNbrChecked = true
        } else {
          this.isCapricorNbrChecked = false
        }
      }).catch(() => {
        this.isCapricorNbrChecked = false
      }).finally(() => {
        this.isDonutActive2 = false
        this.capricornResult = true
        this.isErrorFromSendQuote = false
      })
    },
    checkCapricornNbr() {
      this.isDonutActive2 = true
      this.capricornResult = false;
      this.debounceCheckCapricornNbrFunction()
    },
    sendQuote() {
      if (!this.isCapricorNbrChecked) {
        return
      }
      let data = {
        business: {
          number: this.capricornNumber,
          email: this.capricornEmail,
        },
        parts: this.parts,
        vin: this.vinVehicle,
        make: this.make,
      }
      Axios.post('/stw/quote', data).then((r) => {
        if (r.data._status) {
          this.isSentQuote = true
          this.isErrorFromSendQuote = false
        } else {
          this.isSentQuote = false
          this.isErrorFromSendQuote = true
        }
      }).catch((e) => {
        this.isSentQuote = false
        this.isErrorFromSendQuote = true
      })
    },
  },
}
</script>

<template>
  <div class="">
    <web-camera v-if="isMobile && (isShowCameraPart || isShowCameraAi.vin || isShowCameraAi.parts)"
                :multiple="isShowCameraPart"
                :sendAfterTakePhoto="isShowCameraPart"
                @close="onCloseCamera"
                @send="onSendCamera"
    ></web-camera>
    <div class="d-flex">
      <div class="wrapper-statewide">
        <div class="body-block d-flex">
          <div class="body-block-left">
            <div class="body-block-left-title">Vehicle Information</div>
            <div class="d-flex body-block-left-item">
              <div class="body-block-left-item-name">
                Make
              </div>
              <div class="body-block-left-item-input">
                <multiselect
                  ref="statewideMake"
                  v-model="make"
                  :options="makes"
                  style="width: 100%;  text-transform: uppercase;"
                  :allow-empty="false"
                  :showLabels="false"
                  v-on:keydown.native.down.capture.prevent="changePositionByArrowKey('statewideVinVehicle')"
                ></multiselect>
              </div>
            </div>
            <div class="d-flex body-block-left-item">
              <div class="body-block-left-item-name">
                Vehicle VIN <br>
                <span>Type in or Take a Photo of <br>
                  the BUILD PLATE with VIN
                </span>
              </div>
              <div class="body-block-left-item-input d-flex">
                <input ref="statewideVinVehicle" v-model="vinVehicle" @change="upperCase('vinVehicle')" v-on:keydown.up.prevent="changePositionByArrowKey('statewideMake')" v-on:keydown.down.prevent="changePositionByArrowKey('statewideAddDescription')" type="text"
                  style="width: 100%; text-transform: uppercase;"
                  :class="{ 'red-blinker': showWarningEmptyVinVehicle && vinVehicle == '' }">
                <div style="display: flex; justify-content: center;align-items: center;">
                  <vue-simple-spinner v-if='loadingAi.vin' style="margin-left: 5px;" :size="23"></vue-simple-spinner>
                  <i v-else @click="openCameraAi('vin')" class='bx bxs-camera clickable'></i>
                </div>
              </div>
            </div>
            <div class="d-flex"
              style="margin-top: 40px; padding-top: 10px; border-top: 1px solid rgba(0, 0, 0, .25); margin-right: 20px; justify-content: space-between">
              <div class="body-block-left-title">Create a Parts List</div>
              <div v-if="parts.length > 0" class="body-block-left-mobile-num-parts">{{ parts.length }}</div>
            </div>
            <div class="d-flex body-block-left-item">
              <div class="body-block-left-item-name">
                Add Part Description
              </div>
              <div class="body-block-left-item-input d-flex">
                <input ref="statewideAddDescription" type="text" v-model="description" @change="upperCase('description')" @keyup.enter="addToQuoteList" v-on:keydown.up.prevent="changePositionByArrowKey('statewideVinVehicle')" v-on:keydown.down.prevent="changePositionByArrowKey('partNumber')"
                  style="text-transform: uppercase; color: black !important; -webkit-text-fill-color: black; opacity: 1 !important;">
                <div style="display: flex; justify-content: center;align-items: center;">
                  <vue-simple-spinner v-if='loadingAi.parts' style="margin-left: 5px;" :size="23"></vue-simple-spinner>
                  <i v-else-if="vinVehicle != ''"
                     @click="openCameraAi('parts')"
                     class='bx bxs-camera clickable'
                     ></i>
                </div>
              </div>
            </div>
            <div class="d-flex body-block-left-item">
              <div class="body-block-left-item-name">
                Add Part Number
              </div>
              <div class="body-block-left-item-input d-flex">
                <input type="text" ref="partNumber" v-model="partNumber" @change="upperCase('partNumber')"
                  @input="debouncedSearchPrtNbr" @keyup.enter="addToQuoteList" v-on:keydown.up.prevent="changePositionByArrowKey('statewideAddDescription')" v-on:keydown.down.prevent="focusFirstPartQty" style="padding-right: 27px;  text-transform: uppercase; color: black !important; -webkit-text-fill-color: black; opacity: 1 !important;">
                <div v-if="partNumber.length > 0 && isDonutActive">
                  <div style="text-align: center; margin: 50px auto">
                    <div class="donut"></div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div v-if="isFoundPrtNbrMatch" class="d-flex body-block-left-item">
                <div class="body-block-left-item-name">
                  Available at <br>
                  <span>
                    Locating your nearest <br>
                    Parts dealership.
                  </span>
                  <div>
                    Shop with Confidence <br>
                    <span>Your information Safe</span>
                  </div>
                  <div>
                    Manufacturer Warranty <br>
                    <span>Minimum of 12 Months</span>
                  </div>
                </div>
                <div class="available-right-block">
                  <div class="body-block-left-item-info">
                    <div>
                      <img src="../../../public/auto-logo/audi.png" height="50" width="50">
                    </div>
                    <div class="body-block-left-item-info-title">
                      Fuel Injector Connector
                    </div>
                    <div class="body-block-left-item-info-availability">
                      Stock Availability
                      <span v-if="true" style="color: #00af4f; margin-left: 10px">In stock</span>
                      <span v-if="false" style="color: #fd0000; margin-left: 10px">Get Price & latest Stock quote</span>
                    </div>
                    <div class="body-block-left-item-info-qty">
                      Stock Qty <span style="margin-left: 55px">10 +</span>
                    </div>
                    <div class="body-block-left-item-info-dealership">
                      Your Dealership
                    </div>
                    <div class="body-block-left-item-info-name">
                      AUDI - Zagame Automotive
                    </div>
                    <div class="body-block-left-item-info-num">
                      Tullmarine - 3043
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex body-block-left-item">
              <div class="body-block-left-item-name" style="width: 40%">

              </div>
              <div class="body-block-left-item-input" style="width: 60%; height: 100px">
                <button @click="addToQuoteList" class="btn btn-add-quote"
                  :class="{ 'disabled': isClickedSendForQuote || isDisabledAddToQuoteBtn }" style="width: 100%;">Add
                  to Quote List
                </button>
                <button v-if="isFoundPrtNbrMatch"
                  @click="partNumber = ''; isFoundPrtNbrMatch = false; $refs.partNumber.focus()"
                  class="btn btn-add-quote"
                  style="width: 100%; margin-top: 10px; background-color: #333f4f; border-color: #333f4f;">Search
                  Again
                </button>
              </div>
            </div>

          </div>
          <div class="body-block-right">
            <div class="body-block-right-title" style="color: #562b77;">Parts List</div>
            <div class="body-block-right-subtitle">
              The parts list below will be sent to the dealership for a Price and Latest Stock quote.
            </div>

            <div v-if="parts.length > 0" class="table-body-block-right"
              :class="{ 'gray-table': isClickedSendForQuote }">
              <div class="table-body-block-right-head d-flex">
                <div class="table-body-block-right-title" style="flex-grow: 1;">Part Description</div>
                <div class="table-body-block-right-title" style="width: 70px;">Qty</div>
                <div class="" style="width: 26px"></div>
                <div class="table-body-block-right-title" style="width: 40px"></div>
              </div>
              <div class="table-body-block-right-body">
                <div v-for="(part, index) in parts" class="d-flex table-body-block-right-item"
                  style="margin-bottom: 5px">
                  <progress-bar v-if="part.ai_load" :completed="part.completed"></progress-bar>
                  <template v-else>
                  <div style="flex-grow: 1;">
                    <input
                      :value="(part.partDescription?.length > 0 && part.partNumber?.length > 0) ? (part.partDescription + ' - ' + part.partNumber) : (part.partDescription) ? part.partDescription : part.partNumber"
                      tabindex="-1" readonly type="text" style="width: 100%; font-size: 11px; color: black !important; -webkit-text-fill-color: black; opacity: 1 !important; text-transform: uppercase;">
                  </div>
                  <div style="width: 70px; margin: 0 5px">
                    <input :ref="'statewidePartQty' + index" type="number" min="0" value="1" @keydown="onPressPartArrowKey(index, $event)" class="qty">
                  </div>
                  <div class="" v-if="false && part.isStock"
                    style="width: 67px; background-color: rgb(0, 176, 80); color: white; border-radius: 6px; height: 32px; display: flex; align-items: center; justify-content: center; margin-right: 0px;">
                    In Stock
                  </div>
<!--                  <div v-else>-->
<!--                    <i @click="openCameraParts" class='bx bxs-camera clickable' style="margin-left: 0"></i>-->
<!--                  </div>-->
                  <div class="table-body-block-right-item-icon d-flex" style="width: 50px">
                    <i v-if="!isClickedSendForQuote" @click="parts.splice(index, 1)" class='bx bx-trash' style="color: #c45408; cursor: pointer;"></i>
                    <i v-else class='bx bx-trash' style="color: #bfbfbf;"></i>
                  </div>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="isClickedSendForQuote">
              <div class="body-block-right-title" style="font-weight: 700; font-size: 15px; margin: 15px 0;">SIGN IN or
                Quickly Register an Account.
              </div>
              <div class="body-block-right-subtitle">
                Click on Sign In button above to place this under your account or if your first quote online,
                use your Capricorn number to register an account.
              </div>
              <div class="body-block-right-title" style="font-weight: 700; font-size: 15px; margin-top: 15px;">Capricorn
                Account Number
              </div>
              <div class="body-block-capricon-number-input d-flex">
                <input v-model="capricornNumber" @input="checkCapricornNbr" class="input-capricorn-num active"
                  :readonly="createAccountSuccess">
                <div v-if="isDonutActive2">
                  <div style="text-align: center; margin: 50px auto">
                    <div class="donut2"></div>
                  </div>
                </div>
              </div>
              <button v-if="capricornNumber == ''" @click="provideBusinessDetails" id="btnCapicornAccount"
                :class="{ 'disabled': createAccountSuccess == true }" class="btn btn-add-quote btn-account-capricorn">I
                Don't have Capricorn account
              </button>
              <div v-if="(isAddAccount && !isCapricorNbrChecked)" class="capricorn-account-block">
                <div class="capricorn-account-block-title body-block-right-title"
                  style="margin-top: 15px; font-size: 15px">Provide your Business details
                </div>
                <div class="capricorn-account-block-subtitle body-block-right-subtitle">Address and other contact
                  details are needed to show the parts interpreter preparing your quote.
                </div>
                <div class="capricorn-account-block-elem">
                  <div class="capricorn-account-block-elem-name body-block-right-title" style="font-size: 15px">Business
                    Name <span>*</span></div>
                  <div class="capricorn-account-block-elem-input">
                    <input v-model="createAccountBusinessName" style="width: 100%" class="input-capricorn-num active"
                      :readonly="createAccountSuccess">
                  </div>
                </div>
                <div class="capricorn-account-block-elem">
                  <div class="capricorn-account-block-elem-name body-block-right-title" style="font-size: 15px">Business
                    Address <span>*</span></div>
                  <div class="capricorn-account-block-elem-input">
                    <input v-model="createAccountBusinessAddress" style="width: 100%" class="input-capricorn-num active"
                      :readonly="createAccountSuccess">
                  </div>
                </div>
                <div class="capricorn-account-block-elem">
                  <div class="capricorn-account-block-elem-name body-block-right-title" style="font-size: 15px">Suburb
                    <span>*</span>
                  </div>
                  <div class="capricorn-account-block-elem-input">
                    <input v-model="createAccountSuburb" style="width: 100%" class="input-capricorn-num active"
                      :readonly="createAccountSuccess">
                  </div>
                </div>
                <div class="capricorn-account-block-elem">
                  <div class="capricorn-account-block-elem-name body-block-right-title" style="font-size: 15px">State
                    <span>*</span>
                  </div>
                  <div class="capricorn-account-block-elem-input">
                    <input v-model="createAccountState" style="width: 100%" class="input-capricorn-num active"
                      :readonly="createAccountSuccess">
                  </div>
                </div>
                <div class="capricorn-account-block-elem">
                  <div class="capricorn-account-block-elem-name body-block-right-title" style="font-size: 15px">Postcode
                    <span>*</span>
                  </div>
                  <div class="capricorn-account-block-elem-input">
                    <input v-model="createAccountPostcode" style="width: 100%" class="input-capricorn-num active"
                      :readonly="createAccountSuccess">
                  </div>
                </div>
                <div class="capricorn-account-block-elem">
                  <div class="capricorn-account-block-elem-name body-block-right-title" style="font-size: 15px">Phone
                    Number <span>*</span></div>
                  <div class="capricorn-account-block-elem-input">
                    <input v-model="createAccountPhoneNumber" style="width: 100%" class="input-capricorn-num active"
                      :readonly="createAccountSuccess">
                  </div>
                </div>
                <div class="capricorn-account-block-elem">
                  <div class="capricorn-account-block-elem-name body-block-right-title" style="font-size: 15px">Email
                    Address <span>*</span></div>
                  <div class="capricorn-account-block-elem-input">
                    <input v-model="createAccountEmailAddress" style="width: 100%" @change="checkEmail()"
                      class="input-capricorn-num active" :readonly="createAccountSuccess">
                    <div v-if="createAccountEmailAddress && !isCheckEmail2" class="error-text">This email address is
                      incorrect
                    </div>
                    <div v-if="createAccountEmailAddress && !isCheckEmail" class="error-text">This email is in use or
                      incorrect. Try to use another one
                    </div>
                  </div>
                </div>
                <button v-show="createAccountSuccess == false" :class="{ 'disabled': isDisabledSendBtn }"
                  @click="createAccountBtnSend" class="btn btn-add-quote btn-account-capricorn-send"
                  style="margin-top: 15px">
                  Send
                </button>
                <div v-if="createAccountSuccess">
                  <button style="margin-top: 15px;" class="block-quote-success">Success - Quote Sent
                  </button>
                  <div class="btn-block-text">
                    <p>An email will be sent with your sign-in details.</p>
                    <p>
                      Follow the steps to complete activation so you <br>
                      can manage quotes and place orders.
                    </p>
                  </div>
                </div>

              </div>
              <div class="d-flex" style="margin:10px 0;" v-if="capricornResult && capricornNumber.length">
                <span v-if="!isCapricorNbrChecked || isErrorFromSendQuote" class="body-block-right-title-error">We can`t
                  find that Acc number</span>
                <span v-else class="body-block-right-title-text" style="color: #552a77">
                  {{ repairer.name }} <template v-if="repairer.state || repairer.postcode"> - </template>
                  {{ repairer.state }} <template v-if="repairer.postcode"> - </template>
                  {{ repairer.postcode }}
                </span>
              </div>
              <div v-if="isCapricorNbrChecked">
                <div class="body-block-right-title" style="font-weight: 700; font-size: 15px; margin-top: 15px;">
                  Business Email Address
                </div>
                <div style="height: 66.5px">
                  <input v-model="capricornEmail" class="input-capricorn-num active" :readonly="createAccountSuccess">
                </div>
              </div>
            </div>
            <div class="body-block-left-item" style="margin-top: 10px">
              <button v-if="isClickedSendForQuote && isCapricorNbrChecked && !isSentQuote" @click="sendQuote"
                class="btn btn-add-quote" :class="{ 'disabled': !isCapricorNbrChecked || capricornEmail == '' }"
                :disabled="!isCapricorNbrChecked || capricornEmail == ''">Send
              </button>
              <button @click="isClickedSendForQuote = true"
                v-if="parts.length && !isClickedSendForQuote && !isSentQuote && !isPartsHaveLoadingAi" style="width: calc(100% - 20px)"
                class="btn btn-add-quote">Send for Quote
              </button>
              <div v-if="isSentQuote" class="block-quote-success">Success - Quote Sent</div>
              <div v-if="isSentQuote" class="btn-block-text">
                <p>An email will be sent with your sign-in details.</p>
                <p>
                  Follow the steps to complete activation so you <br>
                  can manage quotes and place orders.
                </p>
              </div>
            </div>
            <div v-if="isSentQuote" class="block-left-dealer">
              <div class="block-left-dealer-title">Your Dealership</div>
              <div class="block-left-dealer-name">AUDI - Zagame Automotive</div>
              <div class="block-left-dealer-info">Tullamarine - 3043</div>
            </div>
          </div>

        </div>
      </div>
      <div class="right-banner">
        <div class="right-banner-item-purple">
          <div>FAST Service</div>
          <div>FAST Delivery</div>
        </div>
        <div class="right-banner-item-grey">
          <div>Australia`s leading</div>
          <div>GENUINE Parts Hub</div>
        </div>
        <div class="right-banner-item-white">
          <div class="right-banner-item-white-elem">
            <div class="right-banner-item-white-elem-title">
              Connect with In-House Experts
            </div>
            <div>
              We know the products
            </div>
          </div>

          <div class="right-banner-item-white-elem">
            <div class="right-banner-item-white-elem-title">
              Shop with Confidence
            </div>
            <div>
              Your information is Safe
            </div>
          </div>

          <div class="right-banner-item-white-elem">
            <div class="right-banner-item-white-elem-title">
              Manufacturer Warranty
            </div>
          </div>
        </div>
      </div>

      <input type="file" ref="fileInput" @change="onFileChange" accept=".jpg, .jpeg, .png" style="display: none;" />
    </div>
  </div>
</template>

<style scoped>
.body-block-left-mobile-num-parts {
  display: none;
}

.body-block-left {
  width: 50%;
}

.body-block-right {
  width: 50%;
}

.right-banner {
  margin-top: 30px;
  width: 230px;
  font-size: 20px;
  position: sticky;
  top: 20px;
  height: 100%;
}

.right-banner-item-purple {
  background-color: #562a78;
  color: #fdcb2d;
  border-radius: 5px;
  font-weight: 600;
  padding: 20px;
  text-align: center;
}

.right-banner-item-grey {
  background-color: #d7d7d7;
  color: rgb(88, 43, 121);
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  font-weight: 600;
}

.right-banner-item-white {
  font-weight: 400;
  padding: 40px 20px;
  font-size: 16px;
}

.right-banner-item-white-elem {
  margin-bottom: 30px;
}

.right-banner-item-white-elem-title {
  font-weight: 800;
}

.gray-table,
.gray-table input,
.gray-table i {
  color: #bfbfbf !important;
}

.available-right-block {
  width: 60%;
}

.body-block-left-item-name {
  width: 40%;
}

.body-block-left-item-input {
  width: 60%;
}

@keyframes donut-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.donut {
  position: absolute;
  top: 7px;
  right: 22px;
  display: inline-block;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #7983ff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: donut-spin 1.2s linear infinite;
}

.donut2 {
  position: absolute;
  top: 16px;
  right: 10px;
  display: inline-block;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #7983ff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: donut-spin 1.2s linear infinite;
}

.body-block-left-item-info-title {
  font-size: 15px;
  color: #6e309e;
  margin-bottom: 5px;
}

.body-block-left-item-info-name {
  color: #6e309e;
}

.body-block-left-item-info-num {
  font-weight: 400;
}

.body-block-left-item-info-availability,
.body-block-left-item-info-qty {
  font-weight: 500;
}

.body-block-left-item-info-qty {
  border-bottom: 1px solid rgba(0, 0, 0, .25);
  padding-bottom: 5px;
  margin-bottom: 5px;
}

.body-block-left-item-info {
  border: 2px solid rgba(0, 0, 0, .25);
  margin: 0 15px;
  height: 100%;
  padding: 0px 15px 15px 15px;
  border-radius: 3px;
}

.body-block-left-item-name div span {
  margin-top: 0;
  font-size: 13px;
}

.body-block-left-item-name div {
  margin-top: 15px;
  font-size: 13px;
}

.input-capricorn-num {
  height: 32px;
  width: calc(100% - 100px);
  margin-top: 10px;
  border: 2px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
}

.input-capricorn-num.active {
  border: 2px solid #6e309e;
}

.btn-block-text {
  margin-top: 20px;
  font-size: 16px;
  color: #6e309e;
  font-weight: 600;
}

.body-block-right-title-error,
.body-block-right-title-text {
  font-weight: 600;
  display: block;
  margin-top: 5px;
  font-size: 15px;
}

.body-block-right-title-error {
  color: red;
}

.block-left-dealer {
  margin-top: 10px;
  border: 2px solid #d7d7d7;
  border-radius: 5px;
  padding: 10px 20px;
  width: calc(100% - 100px)
}

.block-left-dealer-title {
  font-weight: 600;
  font-size: 15px;
}

.block-left-dealer-name {
  font-weight: 600;
  font-size: 15px;
  margin-top: 5px;
  color: rgb(110, 48, 158);
}

.block-left-dealer-info {
  font-weight: 400;
  font-size: 15px;
  margin-top: 5px;
}

.body-block-right-subtitle span {
  font-weight: 600;
}

.body-block-right {
  position: relative;
  min-width: 330px;
}

.table-body-block-right-title {
  font-weight: 700;
  font-size: 15px;
}

.table-body-block-right-item .qty {
  width: 60px;
}

.body-block-right input {
  height: 32px;
  padding: 5px 5px 5px 10px;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}

.table-body-block-right-body {
  margin-top: 10px;
}

.table-body-block-right-head {
  margin-top: 25px;
}

.body-block-left-item-input>>>.multiselect__content-wrapper {
  z-index: 99999;
}

.body-block-left-item-input>>>.multiselect__content-wrapper ul li span {
  text-transform: uppercase;
}

.body-block-left-item {
  margin-top: 10px;
}

.wrapper-statewide {
  font-family: Roboto;
  font-weight: 900;
  margin: 50px auto;
  width: 930px;
}

.header-block {
  font-size: 25px;
  color: black;
  justify-content: space-between;
}

.header-auth {
  margin-top: 40px;
}

.header-line {
  background-color: rgb(227, 228, 231);
  height: 10px;
  border-radius: 5px;
  margin: 60px 45px 0;
  width: 250px;
}

.header-title {
  font-size: 19px;
  text-align: center;
  justify-content: space-between;
  margin-top: 18px;
  font-weight: 700;
}

.header-title-item.active {
  color: rgb(28, 31, 57);
}

.header-title-item {
  color: rgb(128, 130, 134);
}

.body-block {
  padding-top: 25px;
  border-top: 1px solid rgba(0, 0, 0, .25);
  overflow-x: auto;
  overflow-y: auto;
}

.body-block-left {
  border-right: 5px solid rgba(128, 128, 128, 0.4);
  margin-right: 20px;
  min-width: 380px;
}

.body-block-right-title {
  font-size: 19px;
}

.body-block-left-item-name {
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  padding-top: 6px;
}

.body-block-left-item-name span {
  font-weight: 400;
  font-size: 14px;
  margin-top: 10px;
  display: block;
}

.body-block-left-title {
  margin-bottom: 25px;
  font-size: 19px;
}

.body-block-left-item-input {
  padding-right: 15px;
  padding-left: 15px;
  height: 32px;
  position: relative;
}

.body-block-left-item-input>>>.multiselect__tags {
  border: 2px solid rgba(0, 0, 0, .25);
}

.body-block-left-item-input input {
  padding: 5px 10px;
  width: 100%;
  position: relative;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}

.body-block-capricon-number-input {
  height: 32px;
  position: relative;
}

.body-block-capricon-number-input input {
  padding: 5px 10px;
  width: 100%;
  position: relative;
  border-color: rgba(0, 0, 0, .25);
  border-radius: 3px;
}

.btn-add-quote {
  padding: 5px 10px;
  width: 294px;
  height: 42px;
  border: 2px solid #6f309f;
  background-color: #6f309f;
  border-radius: 3px;
  color: white;
  font-weight: 900;
  cursor: pointer;
  font-size: 15px;
}

.btn-add-quote:hover {
  background-color: #5d2985;
  color: white;
}

.block-quote-success {
  background-color: #00af4f;
  border: 2px solid #00af4f;
  color: white;
  border-radius: 3px;
  padding: 8px;
  text-align: center;
  font-weight: 900;
  width: 294px;
}

.bx {
  font-size: 27px;
  position: relative;
  top: 3px;
  margin-left: 5px;
  color: #2e6ba3;
}

.body-block-right-subtitle {
  font-weight: 400;
  font-size: 15px;
  margin-top: 10px;
}

.main-subtitle span {
  font-weight: 800;
}

.main-text {
  font-size: 30px;
  color: rgb(88, 43, 121);
  text-align: center;
  margin-top: 50px;
  font-weight: 600;
  letter-spacing: 1.2px;
  margin-bottom: 50px;
}

.main-text span {
  font-family: "Inter", Arial, Helvetica, sans-serif;
}

.cards {
  flex-wrap: wrap;
}

.card {
  border: 1px solid black;
  margin: 40px 30px;
  padding: 10px 0;
  width: 138px;
  position: relative;
  height: 130px;
}

.card:hover {
  background-color: #f0f2f1;
}

.card img {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

footer {
  background-color: #572b78;
  font-family: "Asap", serif;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}

.footer-block {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}

.footer-logo {
  width: 40%;
}

.footer-main {
  width: 60%;
}

.footer-info {
  width: 33.333%;
}

.footer-info-title {
  color: #ebc018;
  font-size: 25px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: 1.2px;
  margin-bottom: 50px;
}

.footer-info-item {
  color: white;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 25px;
}

.btn.disabled {
  background-color: #c7c7c7;
  border-color: #c7c7c7;
  color: white;
}

.btn-account-capricorn {
  background-color: white;
  color: #6f309f;
  margin-top: 20px;
}

.btn-account-capricorn:hover {
  background-color: #6f309f;
  color: white;
}

.capricorn-account-block-elem-name span {
  color: red;
  font-size: 18px;
}

.capricorn-account-block-elem-name {
  margin-top: 8px;
}

.capricorn-account-block-elem-input .input-capricorn-num {
  margin-top: 3px;
}

.input-capricorn-num[readonly] {
  border-color: rgba(0, 0, 0, .25);
  color: rgba(0, 0, 0, .25);
}

@media (max-width: 950px) {
  .right-banner {
    display: none;
  }

  .wrapper-statewide {
    margin-top: 0;
  }
}

@media (max-width: 767px) {
  .body-block {
    display: block !important;
  }

  .body-block-left {
    width: 100%;
    margin-right: 0;
    border-right: 0;
    border-bottom: 5px solid #6f309f;
  }

  .body-block-right {
    width: 100%;
    margin-top: 25px;
  }

  .body-block-left-mobile-num-parts {
    display: block;
    color: #6f309f;
    height: 35px;
    font-size: 18px;
    text-align: center;
    width: 35px;
    background-color: #e0d4ea;
    border-radius: 999px;
    padding: 5px;
    font-weight: 900;
  }

  .body-block-left .body-block-left-item-input .bxs-camera {
    /*display: none;*/
  }
}

@media (max-width: 700px) {
  .body-block {
    margin-top: 0;
  }

  .wrapper-statewide {
    margin-top: 0;
    width: 100%;
  }
}

@media (max-width: 500px) {
  .body-block-left {
    min-width: 310px;
  }

  .body-block-left-item-input {
    min-width: 230px;
  }

  .available-right-block {
    width: 230px;
  }

  .body-block {
    padding: 5px 0;
  }
}

.red-blinker {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  0% {
    border-color: red;
  }

  50% {
    border-color: rgba(0, 0, 0, .25);
    ;
  }
}
</style>
